var map = {
	"./discover-card.svg": "3urm",
	"./flamingos-rule.svg": "CD8b",
	"./loading-circles.svg": "/ieE",
	"./master-card.svg": "UsEc",
	"./visa-card.svg": "FRhk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "707r";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.svg$
// module id = 707r
// module chunks = 1